const { __, _x, _n, _nx } = wp.i18n;

/**
 * Implements printable replacements for multimedia elements.
 */
var PrintableElements = ( function() {
	var C = function(){ return constructor.apply(this,arguments); };
	var p = C.prototype;

	function constructor() {
		jQuery( 'audio' )
			.each( this.addPrintableAudio.bind( this ) );
		jQuery( 'video' )
			.each( this.addPrintableVideo.bind( this ) );
		jQuery( '.iportal-form-maker' )
			.each( this.addPrintableFormMaker.bind( this ) );
		jQuery( '.iportal-h5p' )
			.each( this.addPrintableH5PEmbed.bind( this ) );
		jQuery( '.iportal-itable' )
			.each( this.addPrintableITable.bind( this ) );
	};

	p.addPrintableAudio = function( i, element ) {
		jQuery( element ).after(
			'<div class="d-none d-print-block"><strong>Audio:</strong> '
				+ '<a href="' + jQuery( element ).attr( 'src' ) + '">'
				+ 'Play in browser'
				+ '</a></div>' )
			.addClass( 'd-print-none' );
	};

	p.addPrintableVideo = function( i, element ) {
		var src = jQuery( element ).find( 'source' ).attr( 'src' );
		jQuery( element ).after(
			'<div class="d-none d-print-block"><strong>Video:</strong> '
				+ '<a href="' + src  + '">'
				+ 'Play in browser'
				+ '</a></div>' )
			.addClass( 'd-print-none' );
	};

	p.addPrintableH5PEmbed = function( i, element ) {
		var iframe = element.querySelector( '.h5p-iframe' );
		if ( ! iframe ) {
			return;
		}
		iframe.classList.add( 'd-print-none' );
		var msg = __( "This multimedia content can only be viewed on the portal website.", 'iportal-core' );
		if ( element.classList.contains( 'iportal-h5p--slides' ) ) {
			msg = __( "This interactive slide show can only be viewed on the portal website.", 'iportal-core' );
		}	else if ( element.classList.contains( 'iportal-h5p--quiz' ) ) {
			msg = __( "This interactive quiz can only be viewed on the portal website.", 'iportal-core' );
		}
		jQuery( iframe ).after(
			'<p class="d-none d-print-block">'
				+ msg
				+ '</p>' );
	};

	p.addPrintableFormMaker = function( i, element ) {
		element.classList.add( 'd-print-none' );
		jQuery( element ).after(
			'<p class="d-none d-print-block">'
				+ __( "This form is only visible on the website version of the portal.", 'iportal-core' )
				+ '</p>' );
	};

	p.addPrintableITable = function( i, element ) {
		element.classList.add( 'd-print-none' );
		jQuery( element ).after(
			'<p class="d-none d-print-block">'
				+ __( "This table is only visible on the website version of the portal.", 'iportal-core' )
				+ '</p>' );
	};

	return C;
} )();

export default PrintableElements;
